export default __webpack_public_path__ + "static/media/question-circle.0b8193db.svg";